module.exports = __webpack_public_path__ + "static/media/travel.7772f83e.svg";